export default "__VITE_ASSET__Br9j8UNY__"